import React, { useState, useEffect } from "react";
import axios from "axios";
import { Slidar } from "../AdminDashbord/Slidar";
import "./AdminTestimonial.css";

const Aboutdat = () => {
  const [about, setAbout] = useState({
    name: "",
    desc: "",
    company: "",
    month: "",
    day: "",
  });
  const [aboutImage, setAboutImage] = useState(null);
  const [aboutList, setAboutList] = useState([]);

  const [editAboutId, setEditAboutId] = useState(null);
  const [showAboutForm, setShowAboutForm] = useState(false);

  const BASE_URL = "";

  useEffect(() => {
    fetchAboutData();
  }, []);

  // Fetch data
  const fetchAboutData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/about`);
      setAboutList(res.data);
    } catch (error) {
      console.error("Error fetching About data:", error);
    }
  };

  // Add / Update
  const handleAboutSubmit = async () => {
    const formData = new FormData();
    if (aboutImage) formData.append("image", aboutImage); // backend expects "image"
    formData.append("name", about.name);
    formData.append("desc", about.desc);
    formData.append("company", about.company);
    formData.append("month", about.month);
    formData.append("day", about.day);

    try {
      if (editAboutId) {
        await axios.put(`${BASE_URL}/api/about/${editAboutId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        alert("✅ About data updated");
        setEditAboutId(null);
      } else {
        await axios.post(`${BASE_URL}/api/about`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        alert("✅ About data added");
      }
      setAbout({ name: "", desc: "", company: "", month: "", day: "" });
      setAboutImage(null);
      setShowAboutForm(false);
      fetchAboutData();
    } catch (err) {
      console.error("❌ Failed to save about data:", err);
      alert("❌ Failed to save about data");
    }
  };

  // Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this entry?")) {
      try {
        await axios.delete(`${BASE_URL}/api/about/${id}`);
        fetchAboutData();
      } catch (error) {
        console.error("❌ Failed to delete:", error);
        alert("❌ Failed to delete about data");
      }
    }
  };

  // Edit
  const handleEdit = (item) => {
    setAbout({
      name: item.name,
      desc: item.desc,
      company: item.company,
      month: item.month,
      day: item.day,
    });
    setEditAboutId(item._id);
    setShowAboutForm(true);
    setAboutImage(null); // reset image (if not changed, backend keeps old one)
  };

  return (
    <div className="admin-testimonial-container">
      {/* Sidebar */}
      <div>
        <Slidar />
      </div>

      {/* Main content */}
      <div className="admin-testimonial-content">
        <hr style={{ margin: "30px 0" }} />

        {/* Toggle Form */}
        <div style={{ textAlign: "right", margin: "30px 0 10px" }}>
          <button
            className="toggle-test-btn"
            onClick={() => {
              setShowAboutForm(!showAboutForm);
              setEditAboutId(null);
              setAbout({ name: "", desc: "", company: "", month: "", day: "" });
              setAboutImage(null);
            }}
          >
            {showAboutForm ? "❌ Close Form" : "➕ Add About Data"}
          </button>
        </div>

        {/* Form */}
        {showAboutForm && (
          <div style={{ marginBottom: "20px" }}>
            <h2>{editAboutId ? "Edit" : "Add"} About Data</h2>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setAboutImage(e.target.files[0])}
            />
            <input
              placeholder="Name"
              value={about.name}
              onChange={(e) => setAbout({ ...about, name: e.target.value })}
            />
            <input
              placeholder="Company"
              value={about.company}
              onChange={(e) => setAbout({ ...about, company: e.target.value })}
            />
            <input
              placeholder="Description"
              value={about.desc}
              onChange={(e) => setAbout({ ...about, desc: e.target.value })}
            />
            <input
              placeholder="Month"
              value={about.month}
              onChange={(e) => setAbout({ ...about, month: e.target.value })}
            />
            <input
              placeholder="Day"
              value={about.day}
              onChange={(e) => setAbout({ ...about, day: e.target.value })}
            />
            <button onClick={handleAboutSubmit}>
              {editAboutId ? "Update" : "Add"} About Data
            </button>
          </div>
        )}

        {/* Table */}
        <div className="table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Image</th>
                <th>Name</th>
                <th>Company</th>
                <th>Description</th>
                <th>Month</th>
                <th>Day</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {aboutList.map((a) => (
                <tr key={a._id}>
                  <td>
                    {a.image ? (
                      <img
                        src={`${BASE_URL}/uploads/${a.image}`}
                        alt={a.name}
                        style={{ borderRadius: "50%", width: "60px", height: "60px", objectFit: "cover" }}
                      />
                    ) : (
                      "No Image"
                    )}
                  </td>
                  <td>{a.name}</td>
                  <td>{a.company}</td>
                  <td>{a.desc}</td>
                  <td>{a.month}</td>
                  <td>{a.day}</td>
                  <td className="action-buttons">
                    <button className="edit-btn" onClick={() => handleEdit(a)}>
                      Edit
                    </button>
                    <button className="delete-btn" onClick={() => handleDelete(a._id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Aboutdat;
